import { AccountScreen } from "@/interactors/AccountScreen";

export default function Account() {
  return <AccountScreen />;
}
